//设备类型的判断以展示不用的item样式
const deviceTypeJudge = oneDevice => {
  let ViewType = ''
  if (
    oneDevice.productCode === '01' ||
    oneDevice.productCode === '05' ||
    oneDevice.productCode === '021'|| 
    oneDevice.productCode ===  '048'  //代号 20231207-1
  ) {
    // 05 感应器 //01 4路通断 021 F路通断
    ViewType = '开关样式'
  } else if (
    oneDevice.productCode === '014' ||
    oneDevice.productCode === '06' ||
    oneDevice.productCode === '02' ||
    oneDevice.productCode === '010'||
    oneDevice.productCode === '049'//代号 20231207-1
  ) {
    // 014 F路调光  06 A电机 02 两路调光
    ViewType = '调光样式'
  } else if (oneDevice.productCode === '03') {
    //  03 四键面板
    ViewType = '四键'
  } else if (oneDevice.productCode === '07') {
    ///07 门锁
    ViewType = '门锁'
  } else if (oneDevice.productCode === '08') {
    ///08 A空调控制
    ViewType = '空调'
  } else if (oneDevice.productCode === '09') {
    // 09 八键面板
    ViewType = '八键'
  } else if (oneDevice.productCode === '013') {
    /// 013 安防控制
    ViewType = '安防'
  } else if (oneDevice.productCode === '015') {
    ///015 A0电机控制
    ViewType = 'A0电机'
  } else if (oneDevice.productCode === '016') {
    ////016  三合一八键环境面板
    ViewType = '环境面板'
  } else if (oneDevice.productCode === '017') {
    //017 A地暖
    ViewType = '地暖'
  } else if (oneDevice.productCode === '018') {
    //018 A新风控制
    ViewType = '新风'
  } else if (oneDevice.productCode === '019') {
    //019 环境探测器
    ViewType = '探测'
  } else if (oneDevice.productCode === '020') {
    //020 F键面板
    ViewType = 'F键面板'
  } else if (oneDevice.productCode === '022') {
    //022 A定时控制
    ViewType = '定时'
  } else if (oneDevice.productCode === '023') {
    //023 F路影视控制
    ViewType = '影视'
  } else if (oneDevice.productCode === '024') {
    //024 A音乐控制
    ViewType = 'A音乐'
  } else if (oneDevice.productCode === '025') {
    // 025 F双色控制
    ViewType = '双色'
  } else if (oneDevice.productCode === '026') {
    // //026 F三色控制
    ViewType = '三色'
  } else if (oneDevice.productCode === '029') {
    ViewType = 'RGBW调光'
  } else if (oneDevice.productCode === '027') {
    //027 W1智能插座
    ViewType = '插座'
  }
  return ViewType
}
//计算出item右下角根据设备状态应该显示的文字
const deviceTypeJudge1 = oneDevice => {
  let value = ''
  if (oneDevice.productCode === '06' || oneDevice.productCode === '010') {//代号20200804-1
    ///说明是A电动窗帘
    if (oneDevice.openStateValue > 0) {
      value = '开/升'
    } else {
      value = '关/降'
    }
  } else if (
    oneDevice.productCode === '03' ||
    oneDevice.productCode === '09' ||
    oneDevice.productCode === '020'
  ) {
    ///4键 8键 F键面板
  } else if (oneDevice.productCode === '025') {
    ///说明是双色调光控制
    if (oneDevice.openState <= 0 && oneDevice.openStateValue <= 0) {
      value = '关'
    } else {
      value = '开'
    }
  } else if (oneDevice.productCode === '026') {
    ///说明是三色调光控制
    if (
      oneDevice.openState <= 0 &&
      oneDevice.openStateValue <= 0 &&
      oneDevice.openStateValue1 <= 0
    ) {
      value = '关'
    } else {
      value = '开'
    }
  } else if (oneDevice.productCode === '029') {
    if (
      oneDevice.openState <= 0 && oneDevice.openStateValue <= 0 &&
      oneDevice.openStateValue1 <= 0 && oneDevice.openStateValue2 <= 0 &&
      oneDevice.openStateValue3 <= 0
    ) {
      value = '关'
    } else {
      value = '开'
    }
  } else if (oneDevice.productCode === '015') {
    //说明是A0电机  有BUG 显示的开关状态和实际的可能对不上，因为用户点了停止的时候，不知道窗帘的状态，所以停止的时候也默认了窗帘是开的状态
    if (oneDevice.openState === 2) {
      value = '关/降'
    } else {
      value = '开/升'
    }
  } else if (
    oneDevice.productCode === '019' ||
    oneDevice.productCode === '023' ||
    oneDevice.productCode === '024'
  ) {
    //说明是环境探测 音乐 影音设备///不需要有状态展示 20200329同移动端一起补的BUG
    value = ''
  } else {
    //说明是通用开关样式
    if (oneDevice.openState === 1) {
      value = '开'
    } else if (oneDevice.openState === 0) {
      value = '关'
    }
  }

  return value
}

///对设备状态 0 和1 进行判断和翻转  参数data为一个设备的综合数据
const deviceStateFlip = oneDevice => {
  if (oneDevice.openState === 0) {
    return (oneDevice.openState = 1)
  } else {
    return (oneDevice.openState = 0)
  }
}
/*
// 功能： 只要传入的多个类型数据...Type 其中有一个 和oneDeviceType相同就会返回true，否则返回false
// oneDeviceType 传入要判断的设备类型码     ...Type  不定参数可以有多个类型数据传入，
 使用示例  
//判断当前设备类型  是否和后面的'01' , '021' , '05'相同，相同返回true  都不相同返回false
// if( publicDeviceTypeJudge(this.oneDevice.productCode, '01' , '021' , '05') )   
*/
const publicDeviceTypeJudge = (oneDeviceType, ...Type) => {
  var numargs = Type.length
  for (let i = 0; i < numargs; i++) {
    if (oneDeviceType === Type[i]) return true
  }
  return false
}

export {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
}
